import { Type } from 'class-transformer';
import { IsArray, IsString, IsUUID, ValidateNested } from 'class-validator';

export class CreateMatchExclusionDto {
	@IsUUID() event_id: string;
	@IsString() ext_api_id: string;
}

export class BulkCreateMatchExclusionsDto {
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => CreateMatchExclusionDto)
	exclusions: CreateMatchExclusionDto[];
}

export interface MatchExclusionDto {
	id: string;
	event_id: string;
	ext_api_id: string;
	created_date: Date;
}

export interface MatchExclusionWithDisplayDto extends MatchExclusionDto {
	start_date: string | null;
	home_team_display: string | null;
	away_team_display: string | null;
}
